import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MyProfileService {
  private apiUrl = environment.hrmsBaseUrl;
  private apiUrlSMS = environment.baseUrl;
  private addDocumentUrl: string = `${this.apiUrl}/api/IdProofs`;
  private getDocuemntsListUrl: string = `${this.apiUrl}/api/IdProofs/user`;
  private getUserByIdUrl: string = `${this.apiUrlSMS}api/User/get-user-info`;

  private certificatesUrl: string = `${this.apiUrl}/api/certifications`;
  private WorkUrl: string = `${this.apiUrl}/api/WorkDetails`;
  private profileImageSource = new BehaviorSubject<string>('');
  profileImage$ = this.profileImageSource.asObservable();

  // used to profile update emit
  private profileUpdatedSource = new BehaviorSubject<boolean>(false);
  profileUpdated$ = this.profileUpdatedSource.asObservable();
  //
  constructor(private http: HttpClient) { }


    emitProfileUpdated() {
      
    this.profileUpdatedSource.next(true);
  }

  updateProfileImage(newImageUrl: string) {
    this.profileImageSource.next(newImageUrl);
  }


  resetProfileImage() {
    this.profileImageSource.next('');
  }

  addDocument(payload: any): Observable<any> {
    return this.http.post<any>(this.addDocumentUrl, payload);
  }

  updateDocument(payload: any): Observable<any> {
    return this.http.put<any>(this.addDocumentUrl, payload);
  }

  getDocumentsByUser(userId: string): Observable<any> {
    return this.http.get<any>(`${this.getDocuemntsListUrl}/${userId}`);
  }

  getUserDetailsById(userId: string): Observable<any> {
    return this.http.get<any>(`${this.getUserByIdUrl}/${userId}`);
  }

  getUserEvents(schoolId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrlSMS}api/User/get-events-of-users/${schoolId}`);
  }

  downloadDocument(id: number): Observable<Blob> {
    return this.http.get(`${this.addDocumentUrl}/${id}/download`, {
      responseType: 'blob',
    });
  }

  deleteDocument(id: number): Observable<any> {
    return this.http.delete<any>(this.addDocumentUrl + '/' + id, {});
  }

  getDocumentsStatusByUser(userId: string): Observable<any> {
    return this.http.get<any>(`${this.getDocuemntsListUrl}/${userId}/stats`);
  }

  verifyDocument(id: number, payload: any): Observable<any> {
    return this.http.put<any>(
      this.addDocumentUrl + '/' + id + '/' + 'verify',
      payload
    );
  }

  //certification
  getCertificatesByUser(userId: string): Observable<any> {
    return this.http.get<any>(`${this.certificatesUrl}/user/${userId}`);
  }

  addCertificate(payload: any): Observable<any> {
    return this.http.post<any>(this.certificatesUrl, payload);
  }

  updateCertificate(id: number, payload: any): Observable<any> {
    return this.http.put<any>(this.certificatesUrl + '/' + id, payload);
  }

  deleteCertificate(id: number): Observable<any> {
    return this.http.delete<any>(this.certificatesUrl + '/' + id, {});
  }

  downloadCertificate(id: number): Observable<Blob> {
    return this.http.get(`${this.certificatesUrl}/${id}/download`, {
      responseType: 'blob',
    });
  }

  verifyCertificate(id: number, payload: any): Observable<any> {
    return this.http.put<any>(
      this.certificatesUrl + '/' + id + '/' + 'verify',
      payload
    );
  }

  //work
  getWorksByUser(userId: string): Observable<any> {
    return this.http.get<any>(`${this.WorkUrl}/user/${userId}`);
  }

  addWorkItem(payload: any): Observable<any> {
    return this.http.post<any>(this.WorkUrl, payload);
  }

  updateWorkItem(id: number, payload: any): Observable<any> {
    return this.http.put<any>(this.WorkUrl + '/' + id, payload);
  }

  deleteWorkItem(id: number): Observable<any> {
    return this.http.delete<any>(this.WorkUrl + '/' + id, {});
  }

  downloadWork(id: number): Observable<Blob> {
    return this.http.get(`${this.WorkUrl}/${id}/download`, {
      responseType: 'blob',
    });
  }

  verifyWork(id: number, payload: any): Observable<any> {
    return this.http.put<any>(
      this.WorkUrl + '/' + id + '/' + 'verify',
      payload
    );
  }
}
